"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coll_type_1 = require("./coll.type");
var CONST_DEVICE_TYPE = 'rf';
var hasGlobalWindowObject = typeof window !== "undefined";
var deviceInfo = {
    deviceType: '',
    osName: '',
    browserName: '',
    browserVer: '',
    screenWidth: hasGlobalWindowObject && window.screen.width || null,
    screenHeight: hasGlobalWindowObject && window.screen.height || null,
};
var _AgentInfo = {
    _init: function () {
        if (hasGlobalWindowObject && window.navigator) {
            _AgentInfo.setDeviceAndOS();
            _AgentInfo.setBrowser();
        }
    },
    setDeviceAndOS: function () {
        var name = 'unknown';
        if (window.navigator.userAgent.indexOf('Android') != -1) {
            name = 'Android';
        }
        else if (window.navigator.userAgent.indexOf('iPhone') != -1) {
            name = 'iPhone';
        }
        else if (window.navigator.userAgent.indexOf('SymbianOS') != -1) {
            name = 'SymbianOS';
        }
        else if (window.navigator.userAgent.indexOf('Windows Phone') != -1) {
            name = 'Windows Phone';
        }
        else if (window.navigator.userAgent.indexOf('iPad') != -1) {
            name = 'iPad';
        }
        else if (window.navigator.userAgent.indexOf('iPod') != -1) {
            name = 'iPod';
        }
        if (name != 'unknown') {
            deviceInfo.osName = name;
            deviceInfo.deviceType = 'mobile';
            return;
        }
        if (window.navigator.userAgent.indexOf('Windows NT 10.0') != -1) {
            name = 'Windows 10';
        }
        else if (window.navigator.userAgent.indexOf('Windows NT 6.2') != -1) {
            name = 'Windows 8';
        }
        else if (window.navigator.userAgent.indexOf('Windows NT 6.1') != -1) {
            name = 'Windows 7';
        }
        else if (window.navigator.userAgent.indexOf('Windows NT 6.0') != -1) {
            name = 'Windows Vista';
        }
        else if (window.navigator.userAgent.indexOf('Windows NT 5.1') != -1) {
            name = 'Windows XP';
        }
        else if (window.navigator.userAgent.indexOf('Windows NT 5.0') != -1) {
            name = 'Windows 2000';
        }
        else if (window.navigator.userAgent.indexOf('Mac') != -1) {
            name = 'Mac/iOS';
        }
        else if (window.navigator.userAgent.indexOf('X11') != -1) {
            name = 'UNIX';
        }
        else if (window.navigator.userAgent.indexOf('Linux') != -1) {
            name = 'Linux';
        }
        deviceInfo.osName = name;
        deviceInfo.deviceType = 'pc';
    },
    setBrowser: function () {
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;
        if ((verOffset = nAgt.indexOf('Opera')) != -1) {
            // In Opera, the true version is after "Opera" or after "Version"
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        else if (nAgt.indexOf('Trident') != -1) {
            // ( ver >= ie7) In MSIE, the true version is after "MSIE" in userAgent
            if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                fullVersion = nAgt.substring(verOffset + 5);
            }
            else {
                fullVersion = '11.0';
            }
            if (fullVersion === '5') {
                fullVersion = '11.0';
            }
            browserName = 'IE';
        }
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
            // In Chrome, the true version is after "Chrome"
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
        }
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
            // In Safari, the true version is after "Safari" or after "Version"
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            // In Firefox, the true version is after "Firefox"
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
        }
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            // In most other browsers, "name/version" is at the end of userAgent
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        if ((ix = fullVersion.indexOf(';')) != -1)
            // trim the fullVersion string at semicolon/space if present
            fullVersion = fullVersion.substring(0, ix);
        if ((ix = fullVersion.indexOf(' ')) != -1)
            fullVersion = fullVersion.substring(0, ix);
        majorVersion = parseInt('' + fullVersion, 10);
        if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }
        deviceInfo.browserName = browserName;
        deviceInfo.browserVer = fullVersion;
    },
    isMobile: function () {
        if (deviceInfo.deviceType == 'mobile') {
            return true;
        }
        return false;
    }
};
_AgentInfo._init(); // 初始化信息
function extendDeviceInfo(log) {
    var originDeviceType = log.deviceType;
    log = extend(log, deviceInfo);
    log.deviceType = log.deviceType || CONST_DEVICE_TYPE;
    // 如果是rf 重写回rf
    if (originDeviceType === 'rf') {
        log.deviceType = originDeviceType;
    }
    return log;
}
/**
 * 配置信息
 */
var configInfo = {};
/*
 * 解决url特殊字符的问题
*/
function encode(query) {
    var str = (query || '').replace('?', '');
    if (hasGlobalWindowObject && window.encodeURIComponent) {
        return encodeURIComponent(str);
    }
    return str;
}
/**
 * 全局配置
 * @param config
 */
function setConfig(config) {
    Object.assign(configInfo, config);
}
exports.setConfig = setConfig;
/**
 * 扩展对象
 *
 * @param target
 * @returns {*}
 */
function extend(target) {
    // var args = Array.prototype.slice.call(arguments, 1);
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var i = 0, len = args.length, arg; i < len; i++) {
        arg = args[i];
        for (var name in arg) {
            if (arg.hasOwnProperty(name)) {
                target[name] = arg[name];
            }
        }
    }
    return target;
}
exports.extend = extend;
/**
 * 将api对象转为最终日志
 * @param apiInfo
 * @returns {string}
 */
function getApi(apiInfo) {
    var log = extend({}, apiInfo);
    log = extendDeviceInfo(log);
    var pageUrl = hasGlobalWindowObject && window.location.href;
    // 处理url
    if (pageUrl) {
        var s = pageUrl.indexOf('?');
        // search 部分要编码
        if (s >= 0) {
            log.pageUrl = pageUrl.substr(0, s);
            // api 场景下，签名不通过，如 ?spm=a21a5.7919994.0.0.21a57674fSGQWb&fetchSchemaApi=/api/taskManage/getPageConfig
            // log.pageQuery = encode(pageUrl.substr(s));
        }
    }
    if (typeof document !== "undefined") {
        log.pageTitle = document.title;
    }
    if (!log.times) {
        log.times = 1;
    }
    if (!log.httpCode) {
        log.httpCode = -1;
    }
    if (!log.code) {
        log.code = '-1';
    }
    if (log.sendTime) {
        var t = new Date().getTime() - log.sendTime;
        log.t = isNaN(t) ? 0 : t;
    }
    if (log.timestamp) {
        var t = new Date(log.timestamp).getTime();
        log.timestamp = isNaN(t) ? log.serverTime : t;
    }
    if (log.url && typeof log.url === 'string') {
        // 如果有querystring,则另存
        var p = log.url.indexOf('?');
        if (p > 0) {
            var q_1 = log.url.substr(p + 1);
            // log.q = typeof encodeURIComponent === 'function' ? encodeURIComponent(q) : '';
            log.url = log.url.substr(0, p);
        }
        // 取url的全路径，但不要协议
        var q = log.url.indexOf('//');
        if (q === 5 || q === 6 || q === 0) {
            log.url = log.url.substr(q + 2);
        }
        else {
            // 相对路径，是否/开头
            p = log.url.indexOf('/');
            if (p != 0) {
                log.url = '/' + log.url;
            }
            var w = typeof window === 'object' ? window : {};
            var l = (w && w.location && w.location.host) || '';
            log.url = l + log.url;
        }
    }
    return log;
}
exports.getApi = getApi;
/**
 * 将jserror对象转为最终日志
 *
 * @param jserror
 * @returns {string}
 */
function getJsError(jserror) {
    var log = extend({ times: 1 }, jserror);
    if (!jserror.url) {
        var urlinfo = getPathSearch();
        log.url = urlinfo[0];
        log.query = urlinfo[1];
    }
    // 处理url
    if (log.url) {
        var s = log.url.indexOf('?');
        // search 部分要编码
        if (s >= 0) {
            log.url = log.url.substr(0, s);
            log.query = log.query || log.url.substr(s);
        }
    }
    if (log.query) {
        log.query = '';
        // log.query = typeof encodeURIComponent === 'function' ? encodeURIComponent(log.query) : '';
    }
    if (typeof document !== "undefined") {
        log.title = document.title;
    }
    log = extendDeviceInfo(log);
    return log;
}
exports.getJsError = getJsError;
/**
 * 将per[性能信息]对象转为最终日志
 *
 * @param per
 * @returns {string}
 */
function getPer(per) {
    var log = extend({}, per);
    log = extendDeviceInfo(log);
    if (!log.url) {
        var win = typeof window === 'object' ? window : {};
        var winUrl = win && win.location;
        log.url = (winUrl || {}).href || '';
    }
    if (log.url) {
        var s = log.url.indexOf('?');
        // search 部分要编码
        if (s >= 0) {
            log.url = log.url.substr(0, s);
            log.query = log.query || log.url.substr(s);
        }
    }
    if (typeof document !== "undefined") {
        log.title = document.title;
    }
    return log;
}
exports.getPer = getPer;
/**
 * 自定义log信息
 *
 * @param log
 * @returns {string}
 */
function getLog(log) {
    var dlog = extend({}, log);
    dlog = extendDeviceInfo(dlog);
    var pageUrl = hasGlobalWindowObject && window.location.href;
    // 处理url
    if (pageUrl) {
        var s = pageUrl.indexOf('?');
        // search 部分要编码
        if (s >= 0) {
            dlog.pageUrl = pageUrl.substr(0, s);
            dlog.pageQuery = pageUrl.substr(s);
        }
    }
    if (typeof document !== "undefined") {
        dlog.pageTitle = document.title;
    }
    return dlog;
}
exports.getLog = getLog;
// 切换url, pathname 和 search, 默认用window.location
function getPathSearch(url) {
    var ret = ['', ''];
    var winUrl = url;
    if (!winUrl) {
        var win = typeof window === 'object' ? window : {};
        winUrl = win && win.location;
        ret[0] = (winUrl || {}).href || '';
        if (winUrl.search) {
            ret[0] = ret[0].split('?')[0];
            var s = winUrl.search;
            var sa = s.split('?');
            if (sa.length > 1) {
                ret[1] = sa[1];
            }
        }
    }
    else {
        ret = url.split('?');
        if (ret.length < 2) {
            ret.push('');
        }
    }
    return ret;
}
exports.getPathSearch = getPathSearch;
function msgEventToJsError(msg, file, line, col, error) {
    var stack = (error && error.stack) || (msg && msg.stack);
    var urlInfo = getPathSearch();
    if (!file) {
        if (typeof msg == 'object' && msg.message) {
            // event处理https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
            var msgEvent = msg;
            try {
                msg = msgEvent.message;
                file = file || msgEvent.filename;
                line = line || msgEvent.lineno;
                col = col || msgEvent.colno;
            }
            catch (e) { }
        }
        else {
            if (typeof msg === 'object') {
                try {
                    msg = JSON.stringify(msg);
                }
                catch (e) { }
            }
        }
        try {
            if (msg) {
                msg = msg.substring(0, 1e3);
            }
            else {
                msg = '';
            }
        }
        catch (e) {
            msg = '';
        }
    }
    var errInfo = extend({}, deviceInfo);
    errInfo = extend({
        url: urlInfo[0],
        query: urlInfo[1],
        category: 'other',
        msg: msg ? msg.substring(0, 1e3) : '',
        stack: stack ? stack.substring(0, 1e3) : ''
    }, deviceInfo);
    if (file || msg === 'Script error.') {
        errInfo.category = 'sys';
        errInfo.file = file;
        errInfo.line = line;
        errInfo.col = col;
    }
    return errInfo;
}
exports.msgEventToJsError = msgEventToJsError;
// 便利对象数据，空value的key剔除掉
function reduceObj(category, data, collType) {
    var logObj = extend({}, data);
    // 得到仓配运的类型
    logObj.collType = coll_type_1.getCollType(collType)[category];
    // 剔除无数据的key
    var reduceObj = {};
    for (var name_1 in logObj) {
        if (logObj.hasOwnProperty(name_1) && (logObj[name_1] === 0 || logObj[name_1] === false || logObj[name_1])) {
            reduceObj[name_1] = logObj[name_1];
        }
    }
    return reduceObj;
}
exports.reduceObj = reduceObj;
// 无线端打点，存储数据
function log(category, data, collType, areaUlr) {
    if (collType === void 0) { collType = 'ware'; }
    var w = weex;
    var writeLog = (function () {
        if (typeof w === 'object') {
            var eventHelper = void 0;
            try {
                eventHelper = w.requireModule('wms-event');
            }
            catch (e) { }
            if (typeof eventHelper === 'object' && typeof eventHelper.writeLog === 'function') {
                return eventHelper.writeLog;
            }
        }
        return function () { };
    })();
    var _area = (function () {
        var locale = 'cn';
        if (typeof w === 'object') {
            try {
                var CNCInternationalization = w.requireModule('CNCInternationalization');
                var langLocale = CNCInternationalization.getBuildLocale();
                locale = langLocale.split('-')[1];
            }
            catch (e) {
                locale = 'cn';
            }
        }
        return locale.toLowerCase();
    })();
    var logObj;
    switch (category) {
        case 'jserror':
            logObj = getJsError(data);
            break;
        case 'api':
            logObj = getApi(data);
            break;
        case 'per':
            logObj = getPer(data);
            break;
        case 'jsonp':
            logObj = data;
        case 'log':
            logObj = getLog(data);
            break;
        default:
            logObj = data;
    }
    //mixin configInfo
    logObj = Object.assign({}, configInfo, logObj);
    if (coll_type_1.CONST_SUB_SOURCE[category]) {
        // 第三个参数做兼容处理，如果是业务类型，则第四个是url, 如果不是，就作为url
        if (coll_type_1.CONST_COLL_TYPE.indexOf(collType) < 0) {
            // 不是大业务类型, 则是url
            collType = 'ware';
            // areaUlr = collType;
        }
        /* else {
                areaUlr = areaUlr || 'https://shidclink.cainiao.com/gateway/link.do';
            } */
        // 得到仓配运的类型
        logObj = reduceObj(category, logObj, collType);
        logObj.locale = _area;
        writeLog({
            subSource: coll_type_1.CONST_SUB_SOURCE[category],
            providerId: coll_type_1.CONST_PROVIDER_ID[category],
            body: JSON.stringify(logObj),
            url: 'https:' + (coll_type_1.CONST_AREA_URL[_area] || coll_type_1.CONST_AREA_URL['cn'])
        });
    }
}
exports.log = log;
//# sourceMappingURL=base.js.map